import * as Styled from '../styled';
import { IRepositoryBranch } from '@/lib/repositoryBranchesApi';
import { CheckIcon } from '@radix-ui/react-icons';
import { Row, Stack } from '@/ui/primatives';
import * as Icon from '@/ui/Icon';
import { CommitInfo } from '../CustomComponents';
import { ICommit } from '@/types';

type BranchOption = {
  value: string;
  label: string;
  type: 'branch' | 'commit';
  branch?: IRepositoryBranch;
  commit: ICommit;
  isDisabled: boolean;
};

const getBranchOptionsList = (
  branches: IRepositoryBranch[],
  disabledBranchNames: string[],
  selectedRef?: string,
  commit?: ICommit | null | undefined,
): BranchOption[] => {
  let options: BranchOption[] = branches.map((branch) => ({
    value: branch.name,
    label: branch.name,
    type: 'branch',
    branch,
    commit: branch.commit,
    isDisabled: disabledBranchNames.includes(branch.name),
  }));

  const selectedBranch = branches.find((branch) => branch.name === selectedRef);

  console.log('commit', commit);

  // if the selected branch is not the same as the commit, add the commit to the options
  if (!!commit && selectedBranch?.commit.id !== commit.id) {
    options.push({
      value: commit.id,
      label: commit.id,
      type: 'commit',
      commit,
      isDisabled: false,
    } as BranchOption);
  }

  // sort by commit timestamp
  options.sort(
    (a, b) =>
      new Date(b.branch?.commit?.timestamp || '').getTime() - new Date(a.branch?.commit?.timestamp || '').getTime(),
  );

  // sort selected branch to the top
  options.sort(function (x, y) {
    return x.value == selectedRef ? -1 : y.value == selectedRef ? 1 : 0;
  });
  return options;
};

const BranchList: React.FC<{
  branches: IRepositoryBranch[];
  disabledBranchNames: string[];
  selectedBranch?: string;
  commit?: ICommit | null | undefined;
  onClick?: (selection: { type: 'branch' | 'commit'; entity: IRepositoryBranch | ICommit }) => void;
}> = ({ branches, disabledBranchNames, selectedBranch, commit, onClick }) => {
  const branchOptions = getBranchOptionsList(branches, disabledBranchNames, selectedBranch, commit);

  return (
    <Styled.List>
      {branchOptions.map((option) => (
        <Styled.ListItem
          key={option.value}
          onClick={() => onClick?.({ type: option.type, entity: option.branch || option.commit })}
        >
          <CheckIcon height="20" width="20" style={{ opacity: option.value === selectedBranch ? 1 : 0 }} />
          <Stack gap={5} className="list-item-content">
            <Row gap={5} alignItems="center">
              {option.type === 'commit' ? <Icon.Commit size="12" /> : <Icon.Branch size="12" />}
              <div className="commitRef">{option.label}</div>
            </Row>
            <CommitInfo commit={option.commit} />
          </Stack>
        </Styled.ListItem>
      ))}
    </Styled.List>
  );
};

export default BranchList;
